import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import Link from '@material-ui/core/Link'
import { Button, Icon } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        // minHeight: '100vh',
    },
    main: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(2),
    },
    footer: {
        padding: theme.spacing(3, 2),
        marginTop: 'auto',
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[800],
    },
}))

export default function Helper() {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Container component="main" className={classes.main} maxWidth="sm">
                <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    endIcon={<Icon>send</Icon>}
                    component={Link}
                    href="mailto:mostra.curitibanos@contato.ufsc.br"
                >
                    {'Dúvidas? Entre em Contato'}
                </Button>
            </Container>
        </div >
    )
}
